import script from "./NotLoggedInOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./NotLoggedInOverlay.vue?vue&type=script&setup=true&lang=js"

import "./NotLoggedInOverlay.vue?vue&type=style&index=0&id=64bc1807&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64bc1807"]])

export default __exports__